
import Vue from "vue";
import { WfOnlineApiKey } from "@/models/wf-online-api-key";
import { WfOnlineApiKeyService } from "@/services/wf-online-api-key-service";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data() {
		return {
			keys: [] as WfOnlineApiKey[],
			newApiKeyName: "",
			newApiKeyModal: false,
			savedApiToken: "",
		};
	},
	computed: {
		hasModlue(): boolean {
			return AuthService.hasModule(this.moduleId);
		},
		moduleId(): MODULE {
			return MODULE.API_ACCESS;
		},
	},
	watch: {
		newApiKeyModal() {
			this.newApiKeyName = "";
		},
	},
	methods: {
		async deleteKey(key: WfOnlineApiKey) {
			let message = this.$ct("are-you-sure-you-want-to-delete-api-key", {name: key.Name});
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!confirm) return;
			await WfOnlineApiKeyService.deleteApiKey(key.ID);
			this.keys = await WfOnlineApiKeyService.getKeys();
		},
		openNewModal() {
			this.newApiKeyModal = true;
		},
		cancelCreate() {
			this.newApiKeyModal = false;
		},
		async createApiKey() {
			let response = await WfOnlineApiKeyService.createApiKey(
				this.newApiKeyName
			);
			this.savedApiToken = response;
			this.newApiKeyModal = false;
			this.keys = await WfOnlineApiKeyService.getKeys();
		},
		copyLink() {
			(
				(this.$refs.savedKeyInput as any)
					.inputElement as HTMLInputElement
			).select();
			document.execCommand("copy");
			this.$wf.notify(this.$ct("coppied"), "success", 3000, "check");
		},
	},
	async created() {
		if (!this.hasModlue) return;
		this.keys = await WfOnlineApiKeyService.getKeys();
	},
	components: {
		AppMissingModule,
	},
	i18nEx: {
		componentPrefix: "components.settings-default",
	},
});
